import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState'; 
import ModulesState from './Modules.State'; 
import ModulesAction from './Modules.Action';
import {CompanySelection} from 'kts-platform-frame/display/part';  
import { MyStore, reducers } from 'kts-platform-frame/redux';

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
}

/** 绑定全局数据到props */ 
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

  constructor(props: IProps) {
      super(props, ModulesAction);
  }  
  render() {
    const { sortList = [], list = [] } = this.modulesState.stateUserlist; 
    return (
      <div className={css.initedcontent} >
        <div className={css.defaultcontent}>
          <div className={css.bigicon}><i className="anticon anticon-relationship"></i></div>
          <div className={css.bigtitle}>我的网络</div>
          <div className={css.totalcompanynum}>- {list.length}个公司 -</div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/display/platform/Network/UI.Network.User.List.Default.tsx